import { localeNameSpaces, useTranslation } from "@payping/utils/localeUtils";

export default function useTranslator(scope?: string) {
  return useTranslation(localeNameSpaces[localeNameSpaces.Wrapper], { keyPrefix: scope || "" });
}
